import useMobile from 'src/hooks/useMobile'
import RedButton from '../components/RedButton'
import { ColoredSpan, SmallText, Highlight, arrowSwirl, tomokoExcitedDefault, speechBubbleMobile, speechBubbleMobileKorean, kfzCharStandard } from '../styles'
import { TopSectionWrapper, LeftGrid, BannerText, ButtonArrow, Tomoko, MobileSpeechBubble, LookingForSounds, rBStyles, mobileRBStyles } from '../styles/TopSection.styles'
import { FaVolumeLow } from 'react-icons/fa6'

const smallTexts = {
  Japanese: <>Based on the <Highlight>best selling</Highlight> &quot;Japanese From Zero!&quot; series.</>,
  Korean: <>Try out our <Highlight>beta</Highlight> courses now!</>
}

const TopSection = ({ scrollToPlanSelect, scrollToSounds = () => null, language = 'Japanese' }) => {
  const isMobile = useMobile(1213)

  return (
    <TopSectionWrapper language={language}>
      {language === 'Korean' && (
        <LookingForSounds onClick={scrollToSounds}>
          <FaVolumeLow />
          {' '}Looking for book sounds?{' '}<span>Click here!</span>
        </LookingForSounds>
      )}
      {isMobile && <MobileSpeechBubble language={language} src={language === 'Japanese' ? speechBubbleMobile : speechBubbleMobileKorean} />}
      <LeftGrid>
        {!isMobile && <ButtonArrow src={arrowSwirl} />}
        <BannerText>Start Learning</BannerText>
        <BannerText><ColoredSpan color='blue'>{language}</ColoredSpan> Today!</BannerText>
        {!isMobile && <SmallText style={{ padding: '12px 12px 30px' }}>{smallTexts[language]}</SmallText>}
        <RedButton language={language} onClick={scrollToPlanSelect} style={isMobile ? mobileRBStyles : rBStyles }>Start Your First Lesson</RedButton>
      </LeftGrid>
      <Tomoko src={language === 'Japanese' ? tomokoExcitedDefault : kfzCharStandard} />
    </TopSectionWrapper>
  )
}

export default TopSection
